import * as Sentry from '@sentry/react'
import { isProduction } from '@/shared/constants/env.ts'

if (isProduction) {
  Sentry.init({
    dsn: 'https://dfc3ae1f07afaec370cc7364cb64f31d@o4506862652555264.ingest.us.sentry.io/4507626152591360',
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/lair\.fi/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  })
}
